import { render, staticRenderFns } from "./SalesVB.vue?vue&type=template&id=0fd42ce2&scoped=true"
import script from "./SalesVB.vue?vue&type=script&lang=js"
export * from "./SalesVB.vue?vue&type=script&lang=js"
import style0 from "./SalesVB.vue?vue&type=style&index=0&id=0fd42ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd42ce2",
  null
  
)

export default component.exports